var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-box ml-code-box"},[_c('button',{staticClass:"copy-button",attrs:{"title":_vm.copyLabel},on:{"click":function($event){$event.preventDefault();return _vm.copyCode.apply(null, arguments)}}},[_c('span',{class:_vm.buttonIcon})]),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.code))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }